import axiosInstance, { ApiKeys, getApiUrl, logError } from '@cp/src/utils/ApiHelper';
import {
  setDocuments,
  setIsDocumentsLoading
} from '@cp/pages/CaseDetails/components/AllDocumentsV2/documentsSlice';
import { Dispatch } from '@reduxjs/toolkit';
import { toast } from '@primitives/Toast';
import { setAccessConsentStatus } from '@cp/src/reducers/commonSlice';
import { AccessConsentGrantPayload, ResourceType } from './types';

export const getDocuments = async (
  dispatch: Dispatch,
  lan: string,
  customerId: string,
  caseReferenceId: string,
  caseBusinessVertical: string
) => {
  try {
    const url = getApiUrl(ApiKeys.CUSTOMER_DOCS);
    dispatch(setIsDocumentsLoading(true));
    const response = await axiosInstance.get(url, {
      headers: {
        customerreferenceid: customerId,
        loanaccountnumber: lan,
        caseReferenceId,
        caseBusinessVertical,
        donotHandleError: true,
        includeInUptimeMetrics: true
      }
    });
    dispatch(setDocuments(response?.data));
  } catch (error) {
    toast.error('Failed to fetch documents');
    return logError(error);
  } finally {
    dispatch(setIsDocumentsLoading(false));
  }
};

export const getAccessConsentCheck =
  (agentId: string, caseReferenceId: string, resourceType: ResourceType) =>
  async (dispatch: Dispatch) => {
    try {
      const url = getApiUrl(ApiKeys.GET_ACCESS_CONSENT_CHECK, null, {
        agentId,
        caseReferenceId,
        resourceType
      });
      const response = await axiosInstance.get(url, { headers: { donotHandleError: true } });
      const status = response?.data?.status;
      dispatch(setAccessConsentStatus(status));
    } catch (error) {
      logError(error);
    }
  };

export const grantAccessConsent =
  (payload: AccessConsentGrantPayload) => async (dispatch: Dispatch) => {
    try {
      const url = getApiUrl(ApiKeys.GET_ACCESS_CONSENT_GRANT);
      const response = await axiosInstance.post(url, payload, {
        headers: { donotHandleError: true }
      });
      const status = response?.data?.status;
      dispatch(setAccessConsentStatus(status));
    } catch (error) {
      logError(error);
    }
  };
